import {
  FiltersForUrl,
  FilterStore,
  FilterStorePeriod,
} from '@/pages/OrdersHistory/components/OrderHistoryFilters/types'
import { FiltersForUrlTypeMap } from '@/pages/OrdersHistory/components/OrderHistoryFilters/constants'
import { useMemo } from 'react'
import {
  getParsedDateFromUrl,
  getSearchFilter,
  validateFilterOptions,
  validatePage,
  validatePageSize,
} from '@/resources/utils'
import { UrlFilterValues } from './types'
import { useUrlFilters } from '@/hooks/url'

const useHistoryUrlFilters = (filtersStore: FilterStore): FilterStore => {
  const getUrlFilters = useUrlFilters<FiltersForUrl>({
    typeMap: FiltersForUrlTypeMap,
  })

  const urlFilters = useMemo(() => getUrlFilters(), [])
  const {
    period: urlPeriod,
    search: searchValue,
    page: urlPage,
    pageSize: urlPageSize,
    ...urlOptions
  } = urlFilters

  const initialStore: FilterStore = useMemo(
    () => ({
      ...filtersStore,
      ...getValidatedFilters(urlOptions),
      search: getSearchFilter(searchValue),
      period: getPeriod(filtersStore.period, urlPeriod),
      page: getValidatedPage(filtersStore.page, urlPage),
      pageSize: getValidatedPageSize(filtersStore.pageSize, urlPageSize),
    }),
    []
  )

  return initialStore
}

const getPeriod = (storePeriod: FilterStorePeriod, urlPeriod?: string[]) => {
  const startDate = urlPeriod?.[0]
  const endDate = urlPeriod?.[1]

  const parsedStart = startDate
    ? getParsedDateFromUrl(startDate)
    : storePeriod.start
  const parsedEnd = endDate ? getParsedDateFromUrl(endDate) : storePeriod.end

  return {
    start: parsedStart ?? storePeriod.start,
    end: parsedEnd ?? storePeriod.end,
  }
}

const getValidatedPage = (urlPage?: number) => validatePage(urlPage)

const getValidatedPageSize = (urlPageSize?: number) =>
  validatePageSize(urlPageSize)

const getValidatedFilters = (urlFilters: UrlFilterValues) => {
  const validated: UrlFilterValues = {}

  Object.entries(urlFilters).forEach(([key, value]) => {
    const prop = key as keyof FilterStore
    validated[prop] = validateFilterOptions(prop, value)
  })

  return validated
}

export default useHistoryUrlFilters
